"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const random_1 = __importDefault(require("random"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('n', (context, args) => {
    let words = [];
    for (let flag of args) {
        let wordList = registries_1.corpusRegistry.get(flag);
        if (!wordList) {
            throw new Error(`Unknown part of speech: ${flag}`);
        }
        words = words.concat(words, [...wordList.values()]);
    }
    return words[random_1.default.int(0, words.length - 1)];
});
